export default __webpack_public_path__ + "static/media/Alex.a807816e.jpg";